module.exports = {
	// 首页
	inbox: "收件箱",
	drafts: "草稿箱",
	sendItems: "已发送",
	deletedItems: "已删除",
	junkEmail: "垃圾箱",
	newMail: "写信",
	newMeeting: "新建会议",
	catalog: "目录列表",
	mailType: "邮件类型",
	unread: "未读",
	total: "总计",
	from: "发件人",
	to: "收件人",
	cc: "抄送",
	subject: "主题",
	all: "全部",
	starred: "有星标",
	noStar: "无星标",
	receiptTime: "接收时间",
	sendTime: "发送时间",
	createTime: "创建时间",
	time: "时间",
	reply: "回复",
	replyAll: "回复所有人",
	forward: "转发",
	delete: "删除",
	deleteCompletely: "彻底删除",
	delConfirm: "删除确认",
	delUnableRecover: "彻底删除后邮件将无法恢复，您确定要删除吗？",
	setAsRead: "设为已读",
	setAsUnread: "设为未读",
	previousPage: "上一页",
	nextPage: "下一页",
	Page: "页数",
	markAsRead: "标记为已读",
	markAsUnread: "标记为未读",
	markAsJunkEmail: "标记为垃圾邮件",
	markAsStar: "标记为星标",
	closePreviewWindow: "关闭预览窗口",
	hideFullInformation: "隐藏完整信息",
	displayFullInformation: "显示完整信息",
	upAndDown: "上下布局",
	leftAndRight: "左右布局",
	exit: "退出",
	refresh: "刷新",
	enterMailbox: "进入邮箱",
	enterMail: "进入邮件",
	enterCalendar: "查看日历",
	enterBPM: "进入BPM",
	enterTheContent: "请输入内容",
	advancedSearch: "高级搜索",
	emptyFolder: "清空文件夹",
	markAllAsRead: "全部标记为已读",
	viewUnread: "查看未读",
	createNewFolder: "新建文件夹",
	rename: "重命名",
	foldername: "文件名",
	renameFolderName: "重命名文件名",
	meetingSelectCondition: "满足所选条件",
	subjectContains: "主题包含",
	senderContains: "发件人包含",
	performFllowOperations: "执行下列操作",
	moveTo: "移动至",
	pleaseInputEmailAddress: "请输入邮箱地址",
	saveSuccess: "保存成功",
	delSuccess: "删除成功",
	pleaseEnterFolderName: "请输入文件夹名",
	createRules: "规则设置",
	read: "已读",
	previousMail: "上一封",
	nextMail: "下一封",
	download: "下载",
	downloadAll: "全部下载",
	editDraft: "编辑草稿",
	trackMail: "邮件跟踪",
	selectWantViewMail: "请选择要查看的邮件",
	noMail: "没有邮件",
	attendees: "与会人",
	attachments: "附件",
	clickDelMmail: "点击删除邮件",
	starMail: "星标邮件",
	attaMail: "带附件邮件",
	cancelStar: "取消星标",
	cancelSuc: "取消成功",
	cancelFail: "取消失败",
	markUnjunkMail: "标记为非垃圾邮件",
	send: "发送",
	isUpdateDraft: "是否保存更新后的草稿？",
	mailTrack: "邮件跟踪情况",
	trackList: "跟踪列表",
	readState: "阅读状态",
	readTime: "阅读时间",
	open: "打开",
	// 高级搜索
	startTime: "开始时间",
	endTime: "结束时间",
	optionDate: "选择日期",
	optionTime: "选择时间",
	folder: "文件夹",
	noRestrictions: "不限",
	includeAttachments: "含附件",
	excludeAttachments: "不含附件",
	search: "搜索",
	cancel: "取消",
	// 写信
	addAttachment: "添加附件",
	singleAttaMax: "单个附件最大50M",
	saveDraft: "存草稿",
	timing: "定时发送",
	mailWillRecipientAtXXX: "本邮件将于xxx投送到对方邮箱",
	emaiWillToMailbox: "本邮件将投送到对方邮箱的时间：",
	discard: "关闭",
	setImportance: "重要性",
	high: "高",
	normal: "正常",
	readReceipt: "已读回执",
	organization: "组织",
	frequentContacts: "常用联系人",
	organizationFramework: "组织架构",
	name: "姓名",
	position: "职务",
	email: "邮箱",
	operation: "操作",
	noPerpsonInfo: "抱歉，没有找到相关人员信息",
	searchNameAndEnter: "请输入需要检索的用户名，按enter键检索",
	createGroup: "创建群组",
	editGroup: "编辑群组",
	delGroup: "删除群组",
	groupMembers: "群组成员",
	noMember: "该群组暂无成员",
	delToFrequentContacts: "删除该常用联系人",
	addToFrequentContacts: "添加至常用联系人",
	groupName: "群组名称",
	enterGroupName: "请输入群组名称",
	confirm: "确定",
	PleaseAddRecipients: "请添加收件人",
	tips: "提示",
	isSaveDraft: "是否保存为草稿？",
	addressBook: "地址簿",
	groupSet: "群组设置",
	yes: "是",
	no: "否",
	// 新建会议
	location: "地点",
	addMeetingLocation: "添加会议地点",
	reminder: "提醒",
	sendMeetingMail: "发送会议邮件",
	pleaseAddAttendees: "请添加与会人",
	pleaseAddMeetingLocation: "请添加会议地点",
	pleaseSelect: "请选择",
	choseRoom: "选择会议室",
	choseRoomList: "选择会议室列表",
	noFreeRoom: "无空闲会议室",
	findFreeRoom: "正在查找空闲会议室",
	free: "空闲",
	// 查看日历
	month: "月",
	today: "今天",
	Sunday: "周日",
	Monday: "周一",
	Tuesday: "周二",
	Wednesday: "周三",
	Thursday: "周四",
	Friday: "周五",
	Saturday: "周六",
	response: "响应",
	accept: "接受",
	tentative: "暂定",
	decline: "谢绝",
	jujue: "拒绝",
	editReplyBeforeSending: "发送前编辑答复",
	sendReplyImmediately: "立即发送答复",
	noReply: "不发送答复",
	meetingTime: "会议时间",
	organizer: "组织者",
	allowSeeFullInfo: "允许对方查看完整详细信息",
	allowSeeLimitInfo: "允许对方查看有限详细信息",
	allowSeeOnlyFeasibility: "允许对方查看仅可行性",
	start: "开始",
	end: "结束",
	noPlace: "无地点",
	notYetAcceptMeeting: "尚未接受此会议",
	// 提示语
	thankPraisePower: "感谢您的点赞，您的满意是我们最大的动力",
	receivedFeedbackFutureOptimi: "已收到您的反馈，我们将在后续做优化",
	mailboxAdded: "该邮箱已经添加",
	inputCorrectEmail: "请输入正确的邮箱地址",
	selectFolder: "请选择文件夹",
	moveSuccess: "移动成功",
	moveFailure: "移动失败",
	enterSearchContent: "请输入搜索内容",
	resetRuleSuccess: "重置规则成功",
	resetRuleFailure: "重置规则失败",
	cancelResetRule: "取消重置规则",
	selectStartSearchTime: "请选择搜索的开始日期",
	selectEndSearchTime: "请选择搜索的结束日期",
	startEarlyEnd: "您选择的结束时间早于开始时间",
	abandonDraftFail: "放弃草稿失败",
	attaDelFail: "附件删除失败，请重试",
	attaUploadFail: "附件上传失败",
	singleAtta50m: "单个附件不能超过50M",
	sendSuccess: "发送成功",
	sendFail: "发送失败",
	saveFail: "保存失败",
	getMailDataFail: "获取邮件数据失败",
	participantAddressFail: "有错误的与会人地址，请修改",
	recaiveAddressFail: "有错误的收件地址，请修改",
	ccAddressFail: "有错误的抄送地址，请修改",
	selectMeetStartDate: "请选择会议开始日期",
	selectMeetStartTime: "请选择会议开始时间",
	selectMeetEndDate: "请选择会议结束日期",
	selectMeetEndTime: "请选择会议结束时间",
	selectMeetRoom: "请选择会议室",
	addFavoriteContactSuc: "添加常用联系人成功",
	newGroupSuc: "新建群组成功",
	editGroupSuc: "编辑群组成功",
	dataLoadErr: "数据加载出错",
	cancelEdit: "取消编辑",
	operationSuc: "操作成功",
	operationFail: "操作失败",
	delFail: "删除失败",
	markSuc: "标记成功",
	markFail: "标记失败",
	verifyCodeFail: "验证码错误",
	createSuc: "创建成功",
	cancelled: "已取消",
	modifySuc: "修改成功",
	clearSuc: "清空成功",
	clearFail: "清空失败",
	setSuc: "设置成功",
	setFail: "设置失败",
	sureEmptyFolder: "您确定要清空文件夹吗?",
	chooseDate: "请选择日期",
	chooseTime: "请选择时间",
	attaLoadFail: "附件加载失败",
	fillEmailSubject: "请填写邮件主题",
	sureDel: "您确定要删除吗？",
	sureLogout: "您确定退出登录吗?",
	doYouResetRule: "是否重置规则?",
	sureDissociateAccount: "确定解除该账号的关联吗?",
	whetherLoadAtta: "是否加载附件?",
	sureDelGroup: "确定要删除群组?",
	outsideEmailTips: "以下收件人在您的组织之外",
	invalidMailboxAddress: "无效的邮箱地址",
	dupNameDelReentet: "该用户出现重名，请删除后重新输入",
	subjectSenderLeastOne: "主题和发件人至少填写一项",
	downloadMessage: '非公司网络下不可下载',
	preview: '预览',
	creatorOperateTip: "您是会议创建者，无需操作",
	requestLimitTip:"请勿频繁操作",
	// 翻译
	selectTranslateLan: "选择翻译语言",
	translateEmail: "翻译邮件",
	translateing: "翻译中...",
	translateFail: "翻译失败",
	showOrigin: "显示原文",
	showTranslate: "显示翻译",
	translateTip: "以下内容为自动翻译结果，仅供参考。"
}



// WEBPACK FOOTER //
// ./src/lang/zh-cn.js